export default __webpack_public_path__ + "static/media/JSCircularBackground-light-sepia-enlarged-700px.jpg.dad03ffa.webp";